/* ============================================================
   SKEAR — Shopify theme interaction layer
   Vanilla JS. Wires to Shopify AJAX Cart API with graceful
   fallback so it also works in the theme editor preview.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Header transparent -> solid ---------- */
  const header = document.querySelector('.header');
  if (header && header.classList.contains('header--transparent')) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Mobile menu ---------- */
  const toggle = document.querySelector('.nav-toggle');
  if (toggle) {
    toggle.addEventListener('click', () => {
      const open = document.body.classList.toggle('menu-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.querySelectorAll('.mobile-nav a').forEach(a =>
      a.addEventListener('click', () => document.body.classList.remove('menu-open')));
  }

  /* ---------- Scroll reveal ---------- */
  const reveals = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(el => io.observe(el));
  } else { reveals.forEach(el => el.classList.add('in')); }

  /* ---------- Accordions ---------- */
  document.querySelectorAll('.acc__head').forEach(head => {
    head.addEventListener('click', () => {
      const item = head.closest('.acc__item');
      const panel = item.querySelector('.acc__panel');
      const open = item.classList.toggle('open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.style.maxHeight = open ? panel.scrollHeight + 'px' : 0;
    });
  });

  /* ---------- Variant selection (Shopify) ---------- */
  document.querySelectorAll('[data-product-form]').forEach(form => {
    const dataEl = form.querySelector('[data-variants]');
    let variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) {}
    const idInput = form.querySelector('[name="id"]');
    const priceOut = document.querySelector('[data-price-output]');
    const atcLabel = form.querySelector('[data-atc-label]');
    const selected = {};

    function money(cents) {
      return (window.Shopify && Shopify.currency ? '' : '$') + (cents / 100).toFixed(2);
    }
    function resolve() {
      const match = variants.find(v => v.options.every((o, i) => selected['option' + (i + 1)] === o));
      const target = match || variants[0];
      if (!target) return;
      if (idInput) idInput.value = target.id;
      if (priceOut) priceOut.textContent = money(target.price);
      if (atcLabel) atcLabel.textContent = target.available ? 'Add to Bag — ' + money(target.price) : 'Sold Out';
      form.querySelectorAll('[data-atc]').forEach(b => { b.disabled = !target.available; });
    }
    form.querySelectorAll('[data-group]').forEach(group => {
      const idx = group.dataset.optionIndex;
      const preset = group.querySelector('[aria-checked="true"]');
      if (preset) selected['option' + idx] = preset.dataset.value || preset.textContent.trim();
      group.querySelectorAll('[role="radio"]').forEach(opt => {
        opt.addEventListener('click', () => {
          group.querySelectorAll('[role="radio"]').forEach(o => o.setAttribute('aria-checked', 'false'));
          opt.setAttribute('aria-checked', 'true');
          selected['option' + idx] = opt.dataset.value || opt.textContent.trim();
          const lbl = group.parentElement.querySelector('[data-selected]');
          if (lbl) lbl.textContent = opt.dataset.value || opt.textContent.trim();
          resolve();
        });
      });
    });
    resolve();
  });

  /* ---------- Cart badge ---------- */
  const badges = document.querySelectorAll('[data-cart-count]');
  function setBadge(n) { badges.forEach(el => { el.textContent = n; el.style.display = n > 0 ? '' : 'none'; }); }

  function toast(msg) {
    let t = document.querySelector('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; document.body.appendChild(t); }
    t.innerHTML = '<span class="g">✦</span>' + msg;
    requestAnimationFrame(() => t.classList.add('show'));
    clearTimeout(t._timer);
    t._timer = setTimeout(() => t.classList.remove('show'), 2600);
  }

  const hasShopifyCart = typeof window.fetch === 'function' && /\/cart|myshopify|\.shop/.test(location.href) || document.body.dataset.shopify === 'true';

  /* ---------- Add to cart ---------- */
  document.querySelectorAll('[data-product-form]').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const idInput = form.querySelector('[name="id"]');
      const name = form.dataset.productForm || 'Item';
      const btn = form.querySelector('[data-atc]');
      if (btn) btn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: idInput ? idInput.value : null, quantity: 1 })
      })
        .then(r => { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(() => fetch('/cart.js').then(r => r.json()))
        .then(cart => { setBadge(cart.item_count); toast('Added to bag — ' + name); })
        .catch(() => { // editor / static fallback
          const n = (parseInt(localStorage.getItem('skear_cart') || '0', 10) + 1);
          localStorage.setItem('skear_cart', n); setBadge(n); toast('Added to bag — ' + name);
        })
        .finally(() => { if (btn) btn.classList.remove('is-loading'); });
    });
  });

  // hydrate badge from Shopify cart on load
  fetch('/cart.js').then(r => r.ok ? r.json() : null).then(c => {
    if (c) setBadge(c.item_count);
    else setBadge(parseInt(localStorage.getItem('skear_cart') || '0', 10));
  }).catch(() => setBadge(parseInt(localStorage.getItem('skear_cart') || '0', 10)));

  /* ---------- Sticky add-to-cart bar ---------- */
  const stickyBar = document.querySelector('.sticky-bar');
  const anchor = document.querySelector('[data-pdp-anchor]');
  if (stickyBar && anchor) {
    new IntersectionObserver((entries) => {
      entries.forEach(en => stickyBar.classList.toggle('show', !en.isIntersecting));
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---------- Collection filter (client-side quick filter) ---------- */
  const chips = document.querySelectorAll('[data-filter]');
  const items = document.querySelectorAll('[data-cat]');
  if (chips.length && items.length) {
    chips.forEach(chip => chip.addEventListener('click', () => {
      chips.forEach(c => c.setAttribute('aria-pressed', 'false'));
      chip.setAttribute('aria-pressed', 'true');
      const f = chip.dataset.filter;
      items.forEach(it => { it.style.display = (f === 'all' || it.dataset.cat === f) ? '' : 'none'; });
    }));
  }

  /* ---------- Policy scroll-spy ---------- */
  const spyLinks = document.querySelectorAll('.policy-nav a');
  const spyTargets = [...spyLinks].map(a => document.querySelector(a.getAttribute('href'))).filter(Boolean);
  if (spyTargets.length) {
    const spy = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) spyLinks.forEach(l => l.classList.toggle('active', l.getAttribute('href') === '#' + e.target.id)); });
    }, { rootMargin: '-20% 0px -70% 0px' });
    spyTargets.forEach(t => spy.observe(t));
  }
})();
